import Vue from 'vue';

import Bootstrapvue from 'bootstrap-vue';

// import { ValidationProvider } from 'vee-validate';
import VeeValidate from 'vee-validate';

import axios from 'axios';
import VueAxios from 'vue-axios';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons/faQuestionCircle';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle';
import { faCcVisa } from '@fortawesome/free-brands-svg-icons/faCcVisa'
import { faCcMastercard } from '@fortawesome/free-brands-svg-icons/faCcMastercard'
import { faCcAmex } from '@fortawesome/free-brands-svg-icons/faCcAmex'
import { faCcDiscover } from '@fortawesome/free-brands-svg-icons/faCcDiscover'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import creditCardValidateRule from './creditCardValidationRule';

import router from './router';
import store from './store';

import App from './App.vue';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

library.add(faExclamationCircle);
library.add(faQuestionCircle);
library.add(faCheckCircle);
library.add(faCcVisa);
library.add(faCcMastercard);
library.add(faCcAmex);
library.add(faCcDiscover);

// Add Vue Extensions
Vue.use(Bootstrapvue);
// Vue.use(VueStyledComponents);
Vue.use(VueAxios, axios);
Vue.use(VeeValidate,
  {
    // classes: true,
    inject: true,
    fieldsBagName: 'veeFields',
    errorBagName: 'veeErrors',
  });

// create a credit card validator
VeeValidate.Validator.extend('creditcard', creditCardValidateRule);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = true;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
